import i18n from '../i18n';

export default {
  namespaced: true,
  state: {
  },
  getters: {
    locale() {
      return i18n.locale;
    },
    localeItems() {
      return i18n.availableLocales;
    },
  },
  mutations: {
    set(state, { locale }) {
      i18n.locale = locale;
    },
  },
  actions: {
  },
};
